module.exports = __webpack_public_path__ + "img/about5.343df2b6.png";